module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker79-api.relevant-digital.com/"}};